import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import cls from 'classnames/bind';

import { getLang } from '@ott/l10n';

import Locale from './blocks/Locale';
import { DROPDOWN_POSITION, DROPDOWN_ALIGN } from './helpers/constants';

import _styles from './LanguageSwitcher.scss';

let defaultOrigin = '/';
if (typeof window !== 'undefined') {
  defaultOrigin = window.location.origin;
}

const defaultGetUrlForSwitchLocale = (selectedLang) =>
  `${defaultOrigin}/set-locale/${selectedLang}`;

const cx = cls.bind(_styles);

class LanguageSwitcher extends PureComponent {
  static propTypes = {
    getUrlForSwitchLocale: PropTypes.func.isRequired,
    showOnlyFlag: PropTypes.bool,
    viewLocales: PropTypes.array,
    dropdownPosition: PropTypes.string,
    dropdownAlign: PropTypes.string,
    dropdownClassName: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    getUrlForSwitchLocale: defaultGetUrlForSwitchLocale,
    showOnlyFlag: false,
    viewLocales: [
      'ru',
      'ru-us',
      // 'ru-ua',
      // 'uk-ua',
      'ru-kz',
      'kz',
      'ru-by',
      'en-gb',
      'en-ie',
      'en-us',
      'es',
      'de',
      'pl',
      'tr',
      'fr',
    ],

    dropdownPosition: DROPDOWN_POSITION.bottom,

    dropdownAlign: DROPDOWN_ALIGN.right,
    dropdownClassName: '',
    className: '',
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.state = {
      isOpen: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  getContainerRef = () => this.containerRef;

  setContainerRef = (node) => (this.containerRef = node);

  handleClickOutside = (event) => {
    const containerRef = this.getContainerRef();

    if (!containerRef || !containerRef.contains(event.target)) {
      this.hideList();
    }
  };

  hideList = () => {
    this.setState({ isOpen: false });
  };

  openList = () => {
    this.setState({ isOpen: true });
  };

  handleSelectLocale = (event, selectedLang) => {
    const { getUrlForSwitchLocale } = this.props;

    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (typeof window !== 'undefined') {
      window.location.href = getUrlForSwitchLocale(selectedLang);
    }
  };

  render() {
    const {
      viewLocales,
      className,
      showOnlyFlag,
      dropdownAlign,
      dropdownClassName,
      dropdownPosition,
    } = this.props;

    const { isOpen } = this.state;

    const selectedLang = getLang();

    const otherLocales = viewLocales.filter((lang) => lang !== selectedLang);

    const hasOthersLocales = otherLocales.length > 0;

    const handleToggleDropdown = isOpen ? this.hideList : this.openList;
    const handleClick = hasOthersLocales ? handleToggleDropdown : undefined;

    return (
      <div
        className={cx('LanguageSwitcher', className)}
        onClick={handleClick}
        ref={this.setContainerRef}
        data-locator="LanguageSwitcher"
      >
        {isOpen && hasOthersLocales && (
          <div
            className={cx('dropdown', dropdownClassName, {
              [`dropdown_${dropdownPosition}`]: dropdownPosition,
              [`dropdown_${dropdownAlign}`]: dropdownAlign,
            })}
            data-locator="list"
          >
            {otherLocales.map((lang) => {
              return (
                <Locale
                  key={lang}
                  lang={lang}
                  selectedLang={selectedLang}
                  onSelectLocale={this.handleSelectLocale}
                  isClickable={true}
                />
              );
            })}
          </div>
        )}
        <div className={cx('currentLocale')} data-locator="currentLocale">
          <Locale
            lang={selectedLang}
            showOnlyFlag={showOnlyFlag}
            selectedLang={selectedLang}
            isClickable={hasOthersLocales}
          />
        </div>
      </div>
    );
  }
}

export default LanguageSwitcher;
